module.exports = require('./helpers/bundle-url').getBundleURL('15Vj6') + "SoT-Here4TN-partners-logo.2d7a3870.png";